import { memo } from 'react';

import { roundToDecimals } from '@/shared/lib/math';
import { Gauge } from '@/shared/ui/gauge';

import cls from './algotech-index.module.css';

interface AlgotechIndexProps {
    value: number;
    className?: string;
}

export const AlgotechIndex = memo(
    ({ value, className }: AlgotechIndexProps) => {
        const roundedValue = roundToDecimals(value);

        return (
            <div className={className}>
                <div className={cls.container}>
                    <Gauge
                        aria-label={`Algotech Index score: ${roundedValue}`}
                        maxValue={100}
                        minValue={0}
                        score={roundedValue}
                    />
                    {/* eslint-disable-next-line i18next/no-literal-string */}
                    <span className={cls.scoreText}>{roundedValue} / 100</span>
                </div>
            </div>
        );
    },
);

AlgotechIndex.displayName = 'AlgotechIndex';
